export function miniLogoDisplay(width: number | undefined): boolean {
    if (width && width > BREAK_POINT_MINI_LOGO) {
        return true
    }
    return false
}
export const BREAK_POINT_MINI_LOGO = 639
